export function validateNamespace (namespace: string): void {
    if (namespace.toLowerCase() !== namespace) {
        throw new Error(`Redux namespace "${namespace}" must be all lowercase.`);
    }
}